<template>
  <div>
    <transition name="modal" id="product-history-dialog">
      <DxPopup
        id="dx-dialog"
        width="100vw"
        height="100vh"
        :hide-on-outside-click="false"
        :show-close-button="true"
        :visible="showPopup"
        :resize-enabled="false"
        :drag-enabled="false"
        @hidden="onHidden"
        :wrapper-attr="popupAttributes"
      >
        <template #title>
          <div class="product-history-header">
            <div class="left_side" @click="buttonCloseEvent">
              <img src="@/assets/images/icons/arrow-back.svg" />
              <span>Înapoi</span>
            </div>
            <div class="right_side">
              <img src="@/assets/images/icons/dialog-close.svg" @click="buttonCloseEvent" />
            </div>
          </div>
        </template>

        <template #content>
          <div class="product-history-container">
            <div class="title-container">
              <img class="title-image" src="@/assets/images/icons/tractor.svg" />
              <div class="title-text">{{ machine?.name ?? "" }}</div>
              <div class="subtitle-text">
                <span> {{ totalCount }} </span> costuri in valoare de <span> {{ totalPrice }} </span> Ron
              </div>
            </div>
            <div class="dialog_title_separator"></div>
            <DxScrollView ref="scrollView" class="product-history-scrollable-container" :element-attr="scrollAttributes" :use-native="true">
              <div>
                <div class="movement-container" v-for="movement in historyData" :key="movement.uuid">
                  <div class="movement-date-container">
                    <div class="movement-date">{{ consumeDate(movement) }}</div>
                    <div class="machine-date-line"></div>
                  </div>
                  <div class="movement-data">
                    <div class="movement-type-price">
                      <div class="movement-type">
                        <div v-if="sourceLabel(movement)" class="movement-source">{{ sourceLabel(movement) }}</div>
                        {{ movement.name || "-" }}
                      </div>
                      <div class="movement-product-price">Valoare (Ron): {{ movement.value | getLocalFormattedQuantity }}</div>
                    </div>
                    <div class="movement-quantity">
                      <div class="movement-quantity-label">Cantitate</div>
                      <div class="movement-quantity-value">{{ movement.quantity | getLocalFormattedQuantity }}</div>
                    </div>
                    <div class="movement-sold">
                      <div class="movement-sold-label">Preț unitar (Ron)</div>
                      <div class="movement-sold-value">{{ movement.unit_price | getLocalFormattedQuantity }}</div>
                    </div>
                  </div>
                  <div v-if="movement.notes" class="movement-notes">
                    {{ movement.notes }}
                  </div>
                  <div class="movement-data">
                    <div class="movement-sold">
                      <i
                        v-if="isDeletableCost(movement)"
                        class="dx-icon dx-icon-trash delete-cost-btn"
                        @click="requestDeleteCost(movement)"
                        :title="$t('common.confirm_delete_title')"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="movement_history_bottom_spacer"></div>
              </div>
            </DxScrollView>
          </div>
        </template>
      </DxPopup>
    </transition>
    <ConfirmDxPopup
      :show="confirmDialog.open"
      :title="$t('common.confirm_delete_title')"
      :message="$t('works.work_machines.confirm_delete_cost')"
      @confirm="confirmDeleteCost"
      @close="closeConfirm"
    />
  </div>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import ConfirmDxPopup from "@/components/Modals/ConfirmDxPopup.vue";
export default {
  name: "MachineConsums",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    templateData: {
      type: Object,
      default: null,
    },
    machine: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      historyData: [],
      totalPrice: 0,
      totalCount: 0,
      deletingIds: {},
      deletedAny: false,
      confirmDialog: {
        open: false,
        movement: null,
      },
      popupAttributes: {
        class: "product_history_dialog_wrapper",
      },
      scrollAttributes: {
        class: "product-history-scroll",
      },
    };
  },
  components: {
    DxPopup,
    DxScrollView,
    ConfirmDxPopup,
  },
  watch: {
    showPopup(newVal) {
      if (newVal) {
        this.getMachineCostsCombined({
          machine_uuid: [this.machine.uuid],
          limit: 99999,
        }).then((response) => {
          this.historyData = response?.data ?? [];
          this.recalcTotals();
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
  },
  methods: {
    ...mapActions({
      getMachineCostsCombined: "works-work-machines/getWorkMachineCostsCombined",
      deleteWorkMachineCost: "works-work-machines/deleteWorkMachineCost",
    }),
    consumeDate(movement) {
      return moment(movement.date)?.format(this.getDefaultDateFormat) ?? movement.date;
    },
    recalcTotals() {
      this.totalPrice = parseFloat(this.historyData.reduce((sum, item) => sum + Number(item.value || 0), 0).toFixed(2));
      this.totalCount = this.historyData.length;
    },
    sourceLabel(movement) {
      const source = movement?.source;
      if (source === "consum") return this.$t("works.work_machines.source_consum");
      if (source === "work_machine_cost") return this.$t("works.work_machines.source_work_machine_cost");
      return null;
    },
    isDeletableCost(movement) {
      return movement?.source === "work_machine_cost" && !!movement?.uuid;
    },
    requestDeleteCost(movement) {
      if (!this.isDeletableCost(movement)) return;
      this.confirmDialog = { open: true, movement };
    },
    closeConfirm() {
      this.confirmDialog = { open: false, movement: null };
    },
    async confirmDeleteCost() {
      const movement = this.confirmDialog.movement;
      if (!movement) {
        this.closeConfirm();
        return;
      }
      await this.performDeleteCost(movement);
      this.closeConfirm();
    },
    async performDeleteCost(movement) {
      if (!this.isDeletableCost(movement)) return;
      if (this.deletingIds[movement.uuid]) return;
      this.$set(this.deletingIds, movement.uuid, true);
      try {
        await this.deleteWorkMachineCost({ uuid: movement.uuid });
        this.historyData = this.historyData.filter((item) => item.uuid !== movement.uuid);
        this.recalcTotals();
        this.deletedAny = true;
      } catch (e) {
        // handled globally
      } finally {
      }
    },
    buttonCloseEvent() {
      this.onHidden();
    },
    onHidden() {
      this.$emit("hidden", { deleted: this.deletedAny });
      this.deletedAny = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/productHistory.scss";
@import "@/assets/scss/global/colors.scss";

.movement-data {
  margin-left: 20px !important;
}

.delete-cost-btn {
  margin-right: 50px !important;
  color: #d9534f;
  cursor: pointer;
  font-size: 24px !important;
  line-height: 1;
}

.movement-type-price {
  display: flex;
  align-items: center;
}

.movement-type-price .movement-product-price {
  margin-left: 16px;
}

.movement-source {
  font-size: 12px;
  color: $brand;
  margin-bottom: 4px;
}
</style>
